import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SmartBotVisibilityManager = () => {
  const location = useLocation();
  const visiblePages = ['/patientDashboardPage', '/signInPage', '/'];

  useEffect(() => {
    const bot = document.getElementById('smartbot360');
    if (!bot) return;

    if (visiblePages.includes(location.pathname)) {
      bot.style.display = 'block';
    } else {
      bot.style.display = 'none';
    }
  }, [location]);

  return null;
};

export default SmartBotVisibilityManager;
